/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $SendScheduleSMSResponse = {
    properties: {
        success: {
    type: 'number',
},
        messageErrors: {
    type: 'array',
    contains: {
    type: 'string',
},
},
    },
};